import { render, staticRenderFns } from "./transaction-summary.vue?vue&type=template&id=3ede8b80&"
import script from "./transaction-summary.vue?vue&type=script&lang=js&"
export * from "./transaction-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports